const TOOL_FRIENDLY_NAMES: Record<string, string> = {};

export function getFriendlyToolName(toolName: string): string {
  return TOOL_FRIENDLY_NAMES[toolName] ?? `Working on ${toolName}…`;
}
